import { computed } from "vue";
import stores from "../stores";

export const configWebOrder = computed(() => {
    const webOrder = stores.getStoresData()
        .setting?.find((s: { key: string }) => s.key === "config_web_order")

    // return null
    return webOrder.value || null
})